/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type addressFragment = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export const addressFragment = gql`
    fragment addressFragment on CreditApplicationAddress {
  city
  state
  street
  streetAdditional
  postalCode
  countryCode
}
    `;